// writing/index.ts
import article from "./article.jpg";
import shortVideo from "./short_video.jpg";
import summary from "./summary.jpg";

const Writing = {
  article,
  shortVideo,
  summary,
};

export default Writing;

// 個別エクスポート
export { article as writingArticle, shortVideo as writingShortVideo, summary as writingSummary };
